import ReactGA from "react-ga4";
import { matchPath } from "react-router-dom";
import SERVER from "constants/server";
import { getVisitId } from "utils/visitIdentity";

// 公開 viewer 的路由；與 App.jsx 的 <Route path="/viewer"> 一致
const VIEWER_ROUTE = "/viewer";
// GA 報表依 object_type 區分物件種類，platform 的 viewer 只有 ScanKit 物件
const SCANKIT_OBJECT_TYPE = "SCANKIT";

// 上一次送出 page_view 的網址（pathname + search），用來避免同一頁重複送
let lastTrackedUrl = null;

// 組出 page_view 參數。只有公開 viewer 帶 object_id / object_type / visit_id，
// 後台頁面一律不帶，避免被算進物件閱覽數。
// visit_id 與 viewer 呼叫物件 API 時帶的 visitId 是同一個值（AM-185），GA 與後端閱覽紀錄可以互相對照。
// 用 matchPath 跟 router 同樣的比對規則（不分大小寫、容許結尾斜線）
export function buildPageViewParams(location) {
  const params = { hitType: "pageview" };
  if (!matchPath(VIEWER_ROUTE, location.pathname)) return params;

  const uid = new URLSearchParams(location.search).get("uid");
  if (!uid) return params;

  return { ...params, object_id: uid, object_type: SCANKIT_OBJECT_TYPE, visit_id: getVisitId() };
}

// 送出 page_view；網址與上一次相同就不送，
// 所以整頁載入時已送過的頁面（例如 /viewer）不會因為 router 掛載再送一次。
// 物件資訊只放在 page_view 事件參數，不用 ReactGA.set，避免殘留到後續事件。
export function trackPageView(location) {
  const url = `${location.pathname}${location.search}`;
  if (url === lastTrackedUrl) return;
  lastTrackedUrl = url;

  ReactGA.send(buildPageViewParams(location));
}

// GA 設定：
// - 明確關掉 config 的自動 page_view（react-ga4 預設已關），page_view 一律由 trackPageView 送，
//   避免日後套件預設改變時重複計數、或送出不帶 object_id 的 page_view
// - viewer 常被嵌在其他網站的 iframe 裡（跨站），cookie 要 SameSite=None;Secure 瀏覽器才會保存，
//   否則每次載入都被當成新的 GA 使用者
export const GTAG_OPTIONS = { send_page_view: false, cookie_flags: "SameSite=None;Secure" };

// 每次整頁載入只呼叫一次：用環境設定的 measurement ID 初始化 GA，並送出這次載入的 page_view。
export function initAnalytics(location = window.location) {
  ReactGA.initialize(SERVER.GA_MEASUREMENT_ID, { gtagOptions: GTAG_OPTIONS });
  trackPageView(location);
}
